import { FormikTouched } from "formik";
import InputErrorMessage from "../InputErrorMessage";

type IValidationErrorMessageProps = {
  errorMessage?: string;
  touched: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
};
export default function ValidationErrorMessage(
  props: IValidationErrorMessageProps,
) {
  const { touched, errorMessage } = props;
  if (touched && errorMessage) {
    return (
      <InputErrorMessage className="c-invalid-tooltip" value={errorMessage} />
    );
  }
  return null;
}
